import { statItems } from "@/mocks/gossipGuide";

const badges = [
  "📝 图文瓜料",
  "🎬 独家视频",
  "🔥 热点线索",
  "🧊 深度整料",
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden pt-24 md:pt-28">
      <div
        className="pointer-events-none absolute -top-24 right-0 h-72 w-72 rounded-full bg-secondary-200/60 blur-3xl"
        aria-hidden="true"
      ></div>
      <div
        className="pointer-events-none absolute -left-20 top-40 h-80 w-80 rounded-full bg-accent-200/50 blur-3xl"
        aria-hidden="true"
      ></div>

      <div className="mx-auto grid w-full max-w-7xl gap-10 px-4 md:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:items-center">
        <div className="relative z-10">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-sm font-semibold text-accent-700">
            <span className="h-2 w-2 rounded-full bg-accent-500" aria-hidden="true"></span>
            吃瓜投稿 · 稿费 · 结算 · 提现
          </span>
          <h1 className="mt-5 text-4xl leading-tight text-foreground-950 sm:text-5xl lg:text-[3.4rem] lg:leading-[1.15]">
            手里有瓜，怎么把它
            <span className="text-primary-500">变成稿费</span>？
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            吃瓜投稿并不是玄学——从一条瓜该值多少钱、稿费单价怎么算，到什么时候结算、怎么提现，这里把手里的料值不值钱一次讲透，让你投稿赚钱不再摸黑。
          </p>
          <div className="mt-7 flex flex-wrap gap-2">
            {badges.map((b) => (
              <span
                key={b}
                className="whitespace-nowrap rounded-full border border-background-300/80 bg-background-50/90 px-4 py-2 text-sm font-medium text-foreground-700"
              >
                {b}
              </span>
            ))}
          </div>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#rates"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-base font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              查看稿费单价
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
            <a
              href="#flow"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-200/80 px-7 py-3.5 text-base font-semibold text-foreground-900 transition-colors hover:bg-background-300"
            >
              从投稿到收钱
            </a>
          </div>
        </div>

        <div className="relative z-10 mx-auto w-full max-w-md lg:max-w-none">
          <div className="relative overflow-hidden rounded-[2rem] bg-background-100 shadow-soft ring-1 ring-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20person%20watching%20juicy%20gossip%20popcorn%20news%20bubbles%2C%20soft%20cream%20background%2C%20orange%20and%20coral%20accents%2C%20playful%20minimal%20flat%20style%2C%20laptop%20and%20phone%20with%20notification%2C%20friendly%20modern%20guidebook%20vibe&width=1000&height=1200&seq=hero-gossip-01&orientation=portrait"
              alt="吃瓜投稿赚钱攻略概念插画：一位投稿者用设备整理爆料素材"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="absolute -left-3 -top-3 rounded-2xl bg-background-50 px-4 py-3 shadow-card ring-1 ring-background-200 sm:-left-5">
            <p className="font-display text-2xl text-primary-500">20~1000</p>
            <p className="text-xs font-medium text-foreground-600">元 / 篇参考区间</p>
          </div>
        </div>
      </div>

      <div className="mx-auto mt-14 w-full max-w-7xl px-4 md:px-6">
        <dl className="grid grid-cols-2 gap-3 rounded-2xl bg-background-50 p-4 shadow-card ring-1 ring-background-200 sm:grid-cols-4 md:p-5">
          {statItems.map((s) => (
            <div key={s.label} className="rounded-xl bg-background-100 px-4 py-4 text-center">
              <dt className="order-2 mt-1 block text-xs font-medium text-foreground-600 md:text-sm">
                {s.label} <span className="hidden sm:inline">· {s.sub}</span>
              </dt>
              <dd className="font-display text-2xl text-foreground-950 md:text-3xl">{s.num}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}